import { Component } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'manuals',
	template: require('./manuals.component.html'),
	host: { class: 'flex-column min-height-full-vh-bg-color' },
})
export class ManualsComponent {
	public isRebrading = AppSettings.isRebrading;
}
